/**
 * Student proficiencies popover
 *
 * This directive behaves slightly differently from conventional component style directives.  The directive doesn't
 * have a template attribute.  The corresponding HTML template is used to dynamically generate the popover DOM upon
 * a user click.
 *
 * This directive is normally used as an element attribute rather than as its own element.
 */
(function(){
  angular.module('EdxClassroomReportModule')
    .directive('edxStudentProficienciesPopover', [
      '$templateRequest',
      '$timeout',
      function(
        $templateRequest,
        $timeout
      ) {
        return {
          restrict: 'AE',
          scope: {
            /** User ID of student to show */
            userId: '=',

            /** Grade level ID to show */
            levelId: '='
          },
          controllerAs: 'vm',
          bindToController: true,
          controller: [
            '$compile',
            '$element',
            '$scope',
            '$state',
            'dblStudentStandardsApi',
            '$templateRequest',
            '$q',
            'navigation',
            'edxStandardsStateParamParser',
            'timeframe',
            EdxStudentProficienciesPopoverController]
        };
      }]);

  function EdxStudentProficienciesPopoverController(
    $compile,
    $element,
    $scope,
    $state,
    dblStudentStandardsApi,
    $templateRequest,
    $q,
    navigation,
    standardsStateParamParser,timeframe) {
    var vm = this;
    vm.formatStandardLabel = formatStandardLabel;

    // Popover options
    var options = {
      animation: false,
      html: true,
      placement: 'bottom',
      trigger: 'manual',
      template: '<div class="popover popover-student-proficiencies" role="tooltip"><div class="arrow" style="left: 5%"></div><div class="popover-content"></div></div>',
    };

    /** Hold promise from pre-loading the popover template */
    var popoverBodyPromise;

    _onInit();

    /**
     * Initialize controller
     * @private
     */
    function _onInit() {

      // Pre-load the popover template
      popoverBodyPromise = $templateRequest('/resources/components/report/classroom/student-proficiencies/edx-student-proficiencies-popover.directive.html')
        .then(function(template){
          return $compile(template)($scope);
        });

      // Because we don't want multiple popovers at once, intercept clicks on the document and close any other popovers
      // which might be open
      $(document).on('click', onDocumentClick);

      // Register for clicks on our element.  We use the 'browser' click event because ng-click doesn't give us access
      // to "our" element
      $element.on('click', onClick);

      // Do cleanup with the controller is destroyed
      $scope.$on('$destroy', function() {
        $element.off('click', onClick);
        $(document).off('click', onDocumentClick);
      });
    }

    /**
     * Load student standards
     * Uses implied district, user and grade level
     * @private
     */
    function _loadStandards() {
      var fromDate = timeframe.getFromDateForAnyTimeframe().format('YYYYMMDD');
      var toDate = timeframe.getToDateForAnyTimeframe().format('YYYYMMDD');
      var standards = standardsStateParamParser.formatCluster(vm.levelId);
      vm.standardsHref = navigation.href({type: 'student', id: vm.userId}, {pane: 'standards', standards: standards});
      return dblStudentStandardsApi.getStudentAll($state.params.districtId, vm.userId, vm.levelId, null, fromDate, toDate);
    }

    /**
     * Load the popover HTML template
     * @private
     */
    function _loadPopoverTemplate() {
      // We already started loading the template during initialization so just return the existing promise
      return popoverBodyPromise;
    }

    /**
     * Show the popover using the given student standards data
     * @param popoverTemplate
     * @param studentStandards
     * @private
     */
    function _showPopoverWithStandards(popoverTemplate, studentStandards) {
      vm.studentStandards = studentStandards;
      options.content = popoverTemplate;
      $element.popover(options).popover('show');

    }

    /**
     * Load data and show popover
     */
    function onClick() {
      $q.all(
        {
          studentStandards: _loadStandards(),
          popoverTemplate: _loadPopoverTemplate()
        }).then(function(results){
          _showPopoverWithStandards(results.popoverTemplate, results.studentStandards);
      });
    }

    /**
     * Format a label for a standard
     *
     * @param standard
     * @returns {string|string|*}
     */
    function formatStandardLabel(standard) {
      return standard.label.indexOf('.') !== -1 ? standard.label : standard.short_description;
    }

    /**
     * Close popovers if mouse is clicked outside the current popover
     * @param e
     */
    function onDocumentClick(e) {
      $('edx-student-proficiencies-popover,[edx-student-proficiencies-popover]').each(function () {
        // don't do anything here if component was clicked or a popover was clicked
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.edx-student-proficiencies-popover').has(e.target).length === 0) {

          // Only hide if open.  Hiding before first open was causeing some popovers
          // to never show.
          var bsPopover = $(this).data('bs.popover');
          var popover = bsPopover ? bsPopover.tip() : undefined;
          if (popover && popover.hasClass('in')) {
            $(this).popover('hide');
          }
        }
      });
    }
  }
})();
